// extracted by mini-css-extract-plugin
export var bannerImage = "JoinTwin-module--bannerImage--aJ0YM";
export var contentOverlay = "JoinTwin-module--contentOverlay--tj61O";
export var contentWrapper = "JoinTwin-module--contentWrapper--sT7D2";
export var description = "JoinTwin-module--description--PlWGw";
export var desktopImage = "JoinTwin-module--desktopImage--K8kSp";
export var joinButton = "JoinTwin-module--joinButton--4pYkg";
export var joinTwinCard = "JoinTwin-module--joinTwinCard--2wkBi";
export var joinTwinSection = "JoinTwin-module--joinTwinSection--sw3Qr";
export var mobileImage = "JoinTwin-module--mobileImage--ut5yB";
export var title = "JoinTwin-module--title--f7dgu";